import * as THREE from 'three';

import { AISLE_WIDTH, BOOTH, NEIGHBOR } from '../config/booth';
import { BRAND, font, makeCanvas, makeTexture } from '../textures/canvas';

function label(text: string, sub?: string): THREE.Mesh {
  const ctx = makeCanvas(1024, sub ? 300 : 180);
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  // Shrink long labels so they never run off the canvas.
  let size = 110;
  ctx.font = font('display', size);
  while (size > 40 && ctx.measureText(text).width > 960) {
    size -= 6;
    ctx.font = font('display', size);
  }
  ctx.fillStyle = 'rgba(255,255,255,0.9)';
  ctx.fillText(text, 512, sub ? 95 : 90);
  if (sub) {
    ctx.font = font('body', 54);
    ctx.fillStyle = 'rgba(255,255,255,0.6)';
    ctx.fillText(sub, 512, 220);
  }
  const tex = makeTexture(ctx);
  const h = sub ? 1.9 : 1.15;
  const m = new THREE.Mesh(
    new THREE.PlaneGeometry(h * (1024 / (sub ? 300 : 180)), h),
    new THREE.MeshBasicMaterial({
      map: tex,
      transparent: true,
      depthWrite: false,
    }),
  );
  m.rotation.x = -Math.PI / 2;
  return m;
}

function dim(x0: number, z0: number, x1: number, z1: number): THREE.Line {
  const geo = new THREE.BufferGeometry().setFromPoints([
    new THREE.Vector3(x0, 0.04, z0),
    new THREE.Vector3(x1, 0.04, z1),
  ]);
  return new THREE.Line(geo, new THREE.LineBasicMaterial({ color: BRAND.red }));
}

/** Floor labels and dimension lines for the plan view. Hidden in walk mode. */
export function buildLabels(): THREE.Group {
  const g = new THREE.Group();
  const W = BOOTH.width;
  const D = BOOTH.depth;

  const main = label('MAIN AISLE', `${AISLE_WIDTH}' assumed`);
  main.position.set(W / 2, 0.05, D + AISLE_WIDTH / 2);
  g.add(main);
  const side = label('CROSS AISLE', `${AISLE_WIDTH}' assumed`);
  side.rotation.z = Math.PI / 2;
  side.position.set(W + AISLE_WIDTH / 2, 0.05, D / 2);
  g.add(side);
  const neighbor = label(
    `BOOTH ${NEIGHBOR.booth}`,
    'neighbor: our side finished, no graphics',
  );
  neighbor.position.set(-NEIGHBOR.width / 2, 0.05, D / 2);
  g.add(neighbor);

  // Usable footprint and the nominal 10x20 line.
  g.add(dim(0, 0, W, 0), dim(W, 0, W, D), dim(W, D, 0, D), dim(0, D, 0, 0));
  const w = label(`19'6" usable (20' nominal)`);
  w.position.set(W / 2, 0.05, D + 1.1);
  g.add(w);
  const d = label(`9'3" usable (10' nominal)`);
  d.rotation.z = Math.PI / 2;
  d.position.set(W + 1.1, 0.05, D / 2);
  g.add(d);
  return g;
}
